module.exports = __webpack_public_path__ + "static/media/stop-insurance-icon.441c4c31.svg";